import axios from "axios";

export const resetPasswordApi = (user, token) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + "/api/sost/utente/" + user.id_utente + "/password/",
        user, {
            headers: {
                jwt: token
            }
        });
};
